module.exports = __webpack_public_path__ + "img/nc.e378f90.svg";